export var mf_product_data_export = { "uid": "mf_product_data_export", "fields": { "title": { "defaultValue": "" }, "catalog_tab_label": { "defaultValue": "Get custom catalog" }, "price_tab_label": { "defaultValue": "Get price list" } } };
